import { ExclamationCircleFilled } from '@ant-design/icons';
import { history } from '@umijs/max';
import { createStyles } from 'antd-style';
import React, { useEffect, useState } from 'react';
import { refreshWallet, subscribeWallet } from '@/services/cloud-billing';

const STYLE_ID = 'sss-arrears-banner-v4';

function ensureAnimStyles() {
  if (typeof document === 'undefined') return;
  const existing = document.getElementById(STYLE_ID);
  if (existing) existing.remove();
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = `
@keyframes sssArrearsIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}
`;
  document.head.appendChild(el);
}

const useStyles = createStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap' as const,
    padding: '11px 20px',
    '@media (max-width: 768px)': {
      padding: '10px 12px',
      gap: 8,
    },
    color: '#a61d24',
    fontSize: 13,
    lineHeight: 1.5,
    background: '#fff1f0',
    borderBottom: '1px solid #ffccc7',
    boxShadow: 'inset 3px 0 0 0 #f5222d',
    animation: 'sssArrearsIn 0.22s ease-out',
  },
  icon: {
    color: '#f5222d',
    fontSize: 18,
    flexShrink: 0,
    lineHeight: 1,
  },
  copy: {
    flex: 1,
    minWidth: 200,
  },
  title: {
    fontWeight: 700,
    color: '#a61d24',
  },
  cta: {
    flexShrink: 0,
    height: 28,
    padding: '0 14px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    background: '#f5222d',
    color: '#fff',
    fontSize: 12,
    fontWeight: 600,
    transition: 'background 0.15s',
    '&:hover': {
      background: '#cf1322',
    },
  },
}));

const SCOPE_LABEL: Record<string, string> = {
  PUSH: '新预警推送',
  ANALYSIS: '算法分析',
  PLAYBACK: '录像回放',
  EXCESS_SMS: '超额短信',
};

const ArrearsBanner: React.FC = () => {
  const { styles } = useStyles();
  const [wallet, setWallet] = useState<API.WalletSummaryVO | null>(null);

  useEffect(() => {
    ensureAnimStyles();
    const unsub = subscribeWallet(setWallet);
    void refreshWallet();
    return unsub;
  }, []);

  if (!wallet?.suspended) return null;

  const scopes =
    wallet.suspendScopes?.map((s) => SCOPE_LABEL[s] || s).join(' / ') ||
    '新预警推送 / 算法分析 / 录像回放 / 超额短信';

  return (
    <div className={styles.root} role="alert">
      <ExclamationCircleFilled className={styles.icon} />
      <div className={styles.copy}>
        <span className={styles.title}>
          {wallet.suspendMessage || '账户余额不足，部分服务已暂停：'}
        </span>
        {wallet.suspendMessage ? null : ` ${scopes} 已暂停，充值后自动恢复`}
      </div>
      <button
        type="button"
        className={styles.cta}
        onClick={() => history.push('/fee-center/balance-recharge')}
      >
        立即充值
      </button>
    </div>
  );
};

export default ArrearsBanner;
